import { ResponsivePie } from "@nivo/pie";
import { useTheme } from "@emotion/react";
import { tokens } from "../theme";
import React from "react";
import { Box, Typography } from "@mui/material";

const PieChart = React.memo(({ data = [] }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isLightMode = theme.palette.mode === "light";

  if (!data.length>0) {
    return (
      <Box
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="h3"
          color={colors.grey[100]}
          textAlign="center"
        >
          Aucune donnée disponible
        </Typography>
      </Box>
    );
  }

  return (
    <ResponsivePie
      data={data}
      theme={{
        background: "transparent",
        text: {
          fontSize: 12,
          fill: colors.grey[100],
        },
        tooltip: {
          container: {
            background: colors.primary[400],
            color: colors.grey[100],
            fontSize: 12,
            borderRadius: "8px",
          },
        },
        legends: {
          text: {
            fill: colors.grey[100],
            fontSize: 12,
          },
        },
      }}
      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
      innerRadius={0.5}
      padAngle={1}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{
        from: "color",
        modifiers: [[isLightMode ? "darker" : "brighter", 0.4]],
      }}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor={colors.grey[100]}
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [[isLightMode ? "darker" : "brighter", 2]],
      }}
      colors={(datum) => datum.data?.color || datum.color || "#ec1d23"}
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          translateY: 56,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: colors.grey[100],
          symbolSize: 14,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemTextColor: colors.greenAccent[500],
              },
            },
          ],
        },
      ]}
    />
  );
});

export default PieChart;
